
  export default {
    props: {
      count: { type: Number, required: true },
      mobileFilterSearchButton: { type: Boolean, default: false },
      mobileFilterButtonString: { type: String, default: '' }
    },
    computed: {
      filterDisplay () {
        return this.$store.getters['utils/getFilterDisplay'];
      },
      filterExtraDisplay () {
        return this.$store.getters['utils/getFilterExtraDisplay'];
      }
    }
  };
